import { render, staticRenderFns } from "./PressScrapCost.vue?vue&type=template&id=525ac164&"
import script from "./PressScrapCost.vue?vue&type=script&lang=js&"
export * from "./PressScrapCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports